module.exports = __webpack_public_path__ + "media/images/app/header/shop-11fbf0c6a997505e3ea67a2a151fdc51.svg";